import { lookupCard } from "../../content/cards.js";
import { EffectIcon, type EffectKey } from "../../components/CardEffectSummary.js";
import type { CardId } from "../../domain/types/index.js";
import { investmentTotals, type InvestmentTotals } from "../../domain/cards/investments.js";

type InvestmentKey = keyof InvestmentTotals;

const ORDER: readonly InvestmentKey[] = ["draw", "progress", "block"];

const LABEL: Record<EffectKey, string> = {
  draw: "カード",
  progress: "進捗",
  block: "防御",
  action: "行動",
  fatigue: "疲労",
};

export function InvestmentTags({ cardIds }: { cardIds: readonly CardId[] | undefined }) {
  const totals = investmentTotals(cardIds);
  const active = ORDER.filter((key) => totals[key] > 0);
  if (active.length === 0) return null;

  const description = (cardIds ?? [])
    .map((id) => lookupCard(id))
    .filter((card): card is NonNullable<typeof card> => Boolean(card))
    .map((card) => `${card.name}（${LABEL[card.investment as InvestmentKey]}+1）`)
    .join("、");

  return (
    <span className="investment-tags" aria-label={`投資：${description}`} title={`投資：${description}`}>
      <span className="investment-label">投資</span>
      {active.map((key) => (
        <span className={`investment-tag is-${key}`} key={key} aria-hidden="true">
          <EffectIcon effect={{ key: key as EffectKey }} />
          <b>+{totals[key]}</b>
        </span>
      ))}
    </span>
  );
}
